// Décode le token JWT pour extraire la date d'expiration (en ms)
export function getTokenExpiration(token) {
  if (!token) return null;
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    return payload.exp ? payload.exp * 1000 : null; // Convertir en millisecondes
  } catch {
    return null;
  }
}
